module.exports = __webpack_public_path__ + "96f935ec30bd4e1c84c2477b97e7d2ec.pdf";